import { memoize as lodashMemoize } from "lodash-es";
export const memoize1 = lodashMemoize;
export function memoize2(func) {
    return lodashMemoize(func, (a, b) => (b == null ? `${a}` : `${a}-${b}`));
}
//# sourceMappingURL=memoize.js.map